// customize the /account/unsubscribe page
if (window.location.pathname === "/account/unsubscribe") {
  const style = document.createElement("style");
  style.textContent = `
    main:has(.shopify-email-marketing-confirmation__container) {
      background-color: #ffdce3;
    }
    .shopify-email-marketing-confirmation__container {
      visibility: hidden;
    }
  `;
  document.head.appendChild(style);

  // replace Shopify's default content
  document.addEventListener("DOMContentLoaded", function () {
    const container = document.querySelector(
      ".shopify-email-marketing-confirmation__container",
    );
    if (container) {
      container.innerHTML = `
        <style>
          .custom-unsubscribe {
            text-align: center;
            padding: 2rem 1.5rem;
          }
          .custom-unsubscribe img {
            margin: 0 auto 2rem;
          }
          .custom-unsubscribe h1 {
            margin: 1rem 0;
          }
          .custom-unsubscribe a {
            display: inline-block;
            margin-top: 2rem;
            background-color: #FF5D73;
            color: white;
            padding: 1rem 2rem;
            text-decoration: none;
            border-radius: var(--buttons-radius)
          }
        </style>
        <div class="custom-unsubscribe">
          <h1>You've been unsubscribed</h1>
          <p>You won't receive any more marketing updates from us.</p>
          <p>You can subscribe again at any time.</p>
          <a href="${window.Shopify.routes.root}">Continue shopping</a>
        </div>
      `;
      container.style.visibility = "visible";
    }
  });
}
